import api from '@/plugins/api'
import { technicalControl as endpoint } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'inspectionTechnicalControl'

export default {
  state: () => ({
    inspection: {},
    headlightDependency: [],
    questions: [],
    exceptionCodes: [],
    exceptionCodesVehicleInspection: [],
    exceptionCodesLightInspection: [],
    exceptionCodesBrakeInspection: [],
    exceptionCodesLightTransmission: [],
    exceptionCodesSmokeInspection: [],
    exceptionCodesGasInspection: [],
    exceptionCodesNoiseInspection: [],
    vehicleSpecialPurpose: [],
    lightTransmissionMeasurement: [],
    brakeMeasurement: {},
    lightMeasurement: {},
    gasMeasurement: [],
    smokeMeasurement: [],
    noiseMeasurement: {},
    hasTurbineOrCompressor: [
      { name: 'Так', value: true },
      { name: 'Ні', value: false }
    ],
    neutralizerList: [
      { id: 1, name: 'Без нейтралізатора'},
      { id: 2, name: 'З окислювальним нейтралізатором'},
      { id: 3, name: 'З трикомпонентним нейтралізатором'}
    ],
    measurementResult: {}
  }),
  mutations: {
    CLEAR_INSPECTION_TECHNICAL_CONTROL (state) {
      state.inspection = {}
      state.headlightDependency = []
      state.questions = []
      state.exceptionCodes = []
      state.exceptionCodesVehicleInspection = []
      state.exceptionCodesLightInspection = []
      state.exceptionCodesBrakeInspection = []
      state.exceptionCodesLightTransmission = []
      state.exceptionCodesSmokeInspection = []
      state.exceptionCodesGasInspection = []
      state.exceptionCodesNoiseInspection = []
      state.vehicleSpecialPurpose = []
      state.lightTransmissionMeasurement = []
      state.brakeMeasurement = {}
      state.lightMeasurement = {}
      state.gasMeasurement=  []
      state.smokeMeasurement = []
      state.noiseMeasurement = {}
      state.measurementResult = {}
    }
  },
  actions: {
    async getHeadlightDependency (context, params) {
      const response = await api.get(endpoint.headlightDependency(params))
      const validationRequest = await requestValidation(response)
      if (validationRequest) {
        context.commit('SET_DATA', { store, state: 'headlightDependency', data: response.data })
      }
      return validationRequest
    },
    async setInspectionTechnicalControl (context, data) {
      const response = await api.post(endpoint.inspection, { body: data.body })
      const validationRequest = await requestValidation(response)
      return { validationRequest, id: response.data.id }
    },
    async getInspectionTechnicalControl (context, id) {
      const response = await api.get(endpoint.vehicleInspection(id))
      const validationRequest = await requestValidation(response)
      if (validationRequest) {
        context.commit('SET_DATA', { store, state: 'inspection', data: response.data })
      }
      return validationRequest
    },
    async updateInspectionTechnicalControl (context, body) {
      const response = await api.patch(endpoint.vehicleInspection(body.id), { body: body.payload })
      const validationRequest = await requestValidation(response)
      if (validationRequest) {
        await context.dispatch('getInspectionTechnicalControl', body.id)
      }
      return validationRequest
    },
    async getInspectionTechnicalControlQuestions (context, id) {
      const response = await api.get(`${ endpoint.inspectionQuestions(id) }`)
      const validationRequest = await requestValidation(response)
      if (validationRequest) {
        context.commit('SET_DATA', { store, state: 'questions', data: response.data })
      }
      return validationRequest
    },
    async getExceptionCodes (context) {
      const response = await api.get(endpoint.exceptionCodes)
      const validationRequest = await requestValidation(response)
      if (validationRequest) {
        context.commit('SET_DATA', { store, state: 'exceptionCodes', data: response.data })
      }
      return validationRequest
    },
    async setInspectionAnswersTechnicalControl (context, data) {
      const response = await api.patch(endpoint.updateArrayOfQuestions(data.inspectionID), { body: data.body })
      return await requestValidation(response)
    },
    async getVehicleSpecialPurpose (context) {
      const response = await api.get(endpoint.vehicleSpecialPurpose)
      const validationRequest = await requestValidation(response)
      if (validationRequest) {
        context.commit('SET_DATA', { store, state: 'vehicleSpecialPurpose', data: response.data })
      }
      return validationRequest
    },
    async getExceptionCodesByTypes (context, types) {
      types.forEach(async type => {
        const params = new URLSearchParams()
        params.append(type.type, true)
        const response = await api.get(`${ endpoint.exceptionCodes }?${ params }`)
        const validationRequest = await requestValidation(response)
        if (validationRequest) {
          context.commit('SET_DATA', { store, state: type.name, data: response.data })
        }
        return validationRequest
      })
    },
    // measurements
    async getMeasurementMtiResult (context, id) {
      const response = await api.get(endpoint.measurementResult(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'measurementResult', data: response.data })
      }
    },
    async getLightTransmissionMeasurementMti (context, id) {
      const response = await api.get(endpoint.lightTransmissionMeasurement(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightTransmissionMeasurement', data: response.data })
      }
      return isResult
    },
    async setLightTransmissionMeasurementMti (context, data) {
      const response = await api.post(endpoint.setLightTransmissionMeasurement(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightTransmissionMeasurement', data: response.data })
        await context.dispatch('getInspectionTechnicalControl', data.id)
      }
      return isResult
    },
    async getBrakeMeasurementTechnicalControl (context, id) {
      const response = await api.get(endpoint.brakeMeasurement(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'brakeMeasurement', data: response.data })
      }
      return isResult
    },
    async setBrakeMeasurementTechnicalControl (context, data) {
      const response = await api.post(endpoint.brakeMeasurement(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'brakeMeasurement', data: response.data })
        await context.dispatch('getInspectionTechnicalControl', data.id)
      }
      return isResult
    },
    async getLightMeasurementTechnicalControl (context, id) {
      const response = await api.get(endpoint.lightMeasurement(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightMeasurement', data: response.data })
      }
      return isResult
    },
    async setLightMeasurementTechnicalControl (context, data) {
      const response = await api.post(endpoint.lightMeasurement(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightMeasurement', data: response.data })
        await context.dispatch('getInspectionTechnicalControl', data.id)
      }
      return isResult
    },
    async getGasMeasurementTechnicalControl (context, id) {
      const response = await api.get(endpoint.getGasMeasurement(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'gasMeasurement', data: response.data.results })
      }
      return isResult
    },
    async setGasMeasurementTechnicalControl (context, data) {
      const response = await api.post(endpoint.setGasMeasurement(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'gasMeasurement', data: response.data })
        await context.dispatch('getInspectionTechnicalControl', data.id)
      }
      return isResult
    },
    async getSmokeMeasurementTechnicalControl (context, id) {
      const response = await api.get(endpoint.getSmokeMeasurement(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'smokeMeasurement', data: response.data.results })
      }
      return isResult
    },
    async setSmokeMeasurementTechnicalControl (context, data) {
      const response = await api.post(endpoint.setSmokeMeasurement(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'smokeMeasurement', data: response.data })
        await context.dispatch('getInspectionTechnicalControl', data.id)
      }
      return isResult
    },
    async getNoiseMeasurementTechnicalControl (context, id) {
      const response = await api.get(endpoint.noiseMeasurement(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'noiseMeasurement', data: response.data })
      }
      return isResult
    },
    async setNoiseMeasurementTechnicalControl (context, data) {
      const response = await api.post(endpoint.noiseMeasurement(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'noiseMeasurement', data: response.data })
        await context.dispatch('getInspectionTechnicalControl', data.id)
      }
      return isResult
    },
    //inspection
    async signInspectionMti (context, id) {
      const response = await api.post(endpoint.signatureInspectionMti, { body: { document: id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getInspectionTechnicalControl', response.data.document)
      }
      return isResult
    },
    async signatureNonComplianceAct (context, data) {
      const response = await api.post(endpoint.signatureNonComplianceAct, { body: { document: data.nonComplianceActId }})
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getInspectionTechnicalControl', data.inspectionId)
      }
      return isResult
    },
    async signatureProtocolMti (context, data) {
      const response = await api.post(endpoint.signatureProtocolMti, { body: { document: data.protocolId }})
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getInspectionTechnicalControl', data.inspectionId)
      }
      return isResult
    },
    async getDocumentMtiInspection (context, id) {
      const response = await api.get(endpoint.getDocumentMtiInspection(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        return response.data.url
      }
      return isResult
    },
    async getProtocolInspectionMti (context, id) {
      const response = await api.get(endpoint.getProtocolMtiInspection(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        return response.data.url
      }
      return isResult
    },
    async getNonComplianceAct (context, id) {
      const response = await api.get(endpoint.getNonComplianceAct(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        return response.data.url
      }
      return isResult
    }
  }
}
